import { inject as myInject } from './inject';

export * from 'mobx-react';
// @ts-ignore
export { default } from 'mobx-react';
export const inject = myInject;
